<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
// import axios from 'axios';
import moment from "moment";
// import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sales Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    // ModelListSelect,
  },
  data() {
    return {
      total_sales: 0,
      total_discount: 0,
      total_profit: 0,
      filterSales:{
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "User Sales Summary",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "User Sales Summary",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "user",
          sortable: true,
          label: 'USER',
        },
        {
          key: "tsales",
          sortable: true,
          label: 'TOTAL SALES',
        },
        {
          key: "discount",
          sortable: true,
          label: 'DISCOUNT',
        },
        {
          key: "tbuying",
          sortable: true,
          label: 'TOTAL COST',
        },
        {
          key: "profit",
          sortable: true,
          label: "PROFIT",
        },
        
      ],
      
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("saledetails", ["filterStatus","UserSalesSummary"]),
    ...mapGetters("auth", ["business","branch","branchid"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.UserSalesSummary ? this.UserSalesSummary.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.UserSalesSummary ? this.UserSalesSummary.length : 1;
  },  
  methods: {
    ...mapActions({
      FetchUserSalesSummary: "saledetails/fetchUserSalesSummary",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      

    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    UserSalesSummaryData() {
      this.FetchUserSalesSummary(this.filterSales);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
},
   
  updated() {
    let total_sales = 0;
    let total_discount = 0;
    let total_profit = 0;
      // let total_paid = 0;
      if(this.UserSalesSummary){
        this.UserSalesSummary.forEach((item)=>{
          total_sales = total_sales+parseInt(item.tsales);
          total_discount = total_discount+parseInt(item.discount);
          total_profit = total_profit+parseInt(item.profit);
        });
        this.total_sales = total_sales;
        this.total_discount = total_discount;
        this.total_profit = total_profit;
        
      }
  },
  watch: {
    UserSalesSummary(newValue){
    let total_sales = 0;
    let total_discount = 0;
    let total_profit = 0;
      if(newValue == true){
        this.UserSalesSummary.forEach((item)=>{
          total_sales = total_sales+parseInt(item.tsales);
          total_discount = total_discount+parseInt(item.discount);
          total_profit = total_profit+parseInt(item.profit);
        });
        this.total_sales = total_sales;
        this.total_discount = total_discount;
        this.total_profit = total_profit;
      }
    }
  },
  created() {
    this.FetchUserSalesSummary(this.filterSales);
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
      <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Users Sales Summary from {{filterSales.datefrom}} to {{filterSales.dateto}}</h3>
              </div>
            </div> 
                       
            <div class="row">
             
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="filterSales.datefrom"
                  class="form-control"
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                  v-model="filterSales.dateto"
                  type="date"
                  class="form-control"
                 
                />
              </div>
             
              <div class="col-md-2 mt-4">
              <button class="btn btn-primary" type="button" @click="UserSalesSummaryData()">
                <span class="fa fa-filter"></span> Filter
                <b-spinner
                  v-show="filterStatus"
                  variant="light"
                  small
                  role="status"
                ></b-spinner>
              </button>
            </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="UserSalesSummary?UserSalesSummary:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>            
              </b-table>
              <div class="row">
                  <!-- <div class="col-md-4"></div> -->
                  <div class="col-md-4">
                    <h5>Total Sales: <span class="text-danger">{{thousandSeperator(total_sales)}}</span></h5>
                  </div>
                   <div class="col-md-4">
                    <h5>Total Discount: <span class="text-danger">{{thousandSeperator(total_discount)}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Total Profit: <span class="text-danger">{{thousandSeperator(total_profit)}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!UserSalesSummary"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
